const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

async function apiRequest(
  endpoint,
  { accessToken, method = "GET", body } = {},
) {
  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    method,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data?.detail || "Notification request failed.");
  }

  return data;
}

/* -------------------------------------------------- */
/* Fetch */
/* -------------------------------------------------- */

export function fetchPlatformNotifications({ accessToken }) {
  return apiRequest("/api/notifications/", { accessToken });
}

export function fetchPlatformNotificationSummary({ accessToken }) {
  return apiRequest("/api/notifications/summary/", { accessToken });
}

/* -------------------------------------------------- */
/* Read */
/* -------------------------------------------------- */

export function markPlatformNotificationAsRead({
  accessToken,
  notificationId,
}) {
  return apiRequest(`/api/notifications/${notificationId}/read/`, {
    accessToken,
    method: "PATCH",
  });
}

export function markAllPlatformNotificationsAsRead({ accessToken }) {
  return apiRequest("/api/notifications/read-all/", {
    accessToken,
    method: "PATCH",
  });
}

/* -------------------------------------------------- */
/* Optional */
/* -------------------------------------------------- */

export function markPlatformNotificationAsUnread({
  accessToken,
  notificationId,
}) {
  return apiRequest(`/api/notifications/${notificationId}/unread/`, {
    accessToken,
    method: "PATCH",
  });
}

/* -------------------------------------------------- */
/* Delete */
/* -------------------------------------------------- */

export function deletePlatformNotification({ accessToken, notificationId }) {
  return apiRequest(`/api/notifications/${notificationId}/`, {
    accessToken,
    method: "DELETE",
  });
}

export function deletePlatformNotifications({ accessToken, notificationIds }) {
  return apiRequest("/api/notifications/delete/", {
    accessToken,
    method: "DELETE",
    body: {
      ids: notificationIds,
    },
  });
}

export async function markSelectedNotificationsAsRead({
  accessToken,
  notificationIds,
}) {
  const response = await fetch(
    `${API_BASE_URL}/api/notifications/read-selected/`,
    {
      method: "PATCH",

      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },

      body: JSON.stringify({
        ids: notificationIds,
      }),
    },
  );

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      data?.detail || "Could not mark the selected notifications as read.",
    );
  }

  return data;
}
